/**
 * Boost PFS Polyfill - Fix for "o2 is not defined" parseHTML error
 *
 * ROOT CAUSE: The minified boost-pfs-vendor.js has a Temporal Dead Zone violation
 * in its parseHTML function where variables are accessed before their declarations.
 *
 * SOLUTION: Wrap BoostPFS.jQ.parseHTML with error handling to catch the TDZ error
 * and provide a working fallback using standard DOM methods.
 *
 * TIMING: This script MUST load AFTER boost-pfs-core.js (which creates BoostPFS.jQ)
 * and BEFORE boost-pfs-filter.js (which uses parseHTML).
 */

(function() {
  'use strict';

  var patchApplied = false;
  var patchAttempts = 0;
  var maxAttempts = 10;

  // Patch BoostPFS jQuery parseHTML
  function patchBoostPFSjQuery() {
    patchAttempts++;

    // Verify BoostPFS.jQ exists
    if (!window.BoostPFS || !window.BoostPFS.jQ) {
      console.warn('[BoostPFS Polyfill] BoostPFS.jQ not available yet (attempt ' + patchAttempts + '/' + maxAttempts + ')');
      return false;
    }

    // Verify parseHTML exists
    if (typeof window.BoostPFS.jQ.parseHTML !== 'function') {
      console.error('[BoostPFS Polyfill] BoostPFS.jQ exists but parseHTML is not a function');
      return false;
    }

    // Store the original parseHTML
    var originalParseHTML = window.BoostPFS.jQ.parseHTML;

    // Wrap parseHTML with error handling and fallback
    window.BoostPFS.jQ.parseHTML = function(data, context, keepScripts) {
      try {
        // Ensure context defaults to document
        context = context || document;
        return originalParseHTML.call(this, data, context, keepScripts);
      } catch (e) {
        // Log the error for debugging
        console.warn('[BoostPFS Polyfill] parseHTML error caught, using fallback:', e.message);

        // Fallback implementation using standard DOM methods
        if (typeof data !== 'string') {
          return [];
        }

        // Create a temporary element to parse HTML
        var tmp = (context || document).createElement('div');
        tmp.innerHTML = data;

        // Extract all child nodes
        var nodes = [];
        for (var i = 0; i < tmp.childNodes.length; i++) {
          nodes.push(tmp.childNodes[i]);
        }

        // Remove scripts if keepScripts is false (default behavior)
        if (!keepScripts) {
          nodes = nodes.filter(function(node) {
            return node.nodeType !== 1 || node.tagName.toLowerCase() !== 'script';
          });
        }

        return nodes;
      }
    };

    console.log('[BoostPFS Polyfill] ✅ parseHTML successfully patched');
    patchApplied = true;
    return true;
  }

  // Attempt to patch immediately (core.js should have loaded)
  if (patchBoostPFSjQuery()) {
    return; // Success on first attempt
  }

  // If not successful, listen for DOMContentLoaded as fallback
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      if (!patchApplied && !patchBoostPFSjQuery()) {
        // Final fallback: retry after 500ms
        setTimeout(function() {
          if (!patchApplied) {
            patchBoostPFSjQuery();
          }
        }, 500);
      }
    });
  } else {
    // DOM already ready, try with delay
    setTimeout(function() {
      if (!patchApplied) {
        patchBoostPFSjQuery();
      }
    }, 500);
  }

  // Add a global flag to indicate polyfill has loaded
  window.__boostPFSPolyfillLoaded = true;

})();
